<template>
    <div>
      <CRow>
        <CCol sm="12" md="12">
          <CCard accent-color="primary">
            <CCardHeader
              class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
            >
              Ver Prestacion Folio:{{folio}}
              <div>
                <!-- <router-link :to="{
                        name: 'EditPrestacion',
                        params: {
                          folio: folio,
                          config: config
                        }
                      }">
                  <CButton color="success" class="mr-1 btn-header">
                    <CIcon class="mr-1" name="cil-pencil" />Editar
                  </CButton>
                </router-link> -->
                <!-- <CButton color="info" class="mr-1 btn-header" @click="getReporte">
                  <i v-if="loader" class="fa fa-spinner fa-pulse mr-1"></i>
                  <CIcon v-else class="mr-1" :name="`cil-cloud-download`" />PDF
                </CButton> -->
                <BackButton :to="{ name: backInfo, params: { config: config } }">
                  <CButton color="primary" class="mr-1 btn-header">
                    <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
                  </CButton>
                </BackButton>
              </div>
            </CCardHeader>
  
            <CCardBody v-if="isLoading">
              <div class="w-100 d-flex justify-content-center align-items-center">
                <div class="sk-flow">
                  <div class="sk-flow-dot bg-primary"></div>
                  <div class="sk-flow-dot bg-primary"></div>
                  <div class="sk-flow-dot bg-primary"></div>
                </div>
              </div>
            </CCardBody>
  
            <CCardBody v-else>
              <CRow>
                <CCol sm="12" class="text-right">
                  {{ item.author?item.author.correo:'' }}
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <label>Fecha:</label>
                  <CInput v-model="date" disabled type="date" horizontal />
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <label>Trabajador:</label>
                  <CInput v-model="trabajador" disabled horizontal />
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <label>Actividad:</label>
                  <CInput v-model="actividad" disabled horizontal />
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="12" md="9" lg="9">
                  <CInput
                    v-model="cantidad"
                    disabled
                    :label="`Cantidad producida${getUnidad()}: `"
                    placeholder="Cantidad producción.."
                    type="number"
                  />
                </CCol>
                <!-- <CCol>
                  <label>Tiempo extra:</label>
                  <br />
                  <CSwitch
                    disabled
                    class="mx-1"
                    color="primary"
                    :checked="tiempo_extra"
                    variant="3d"
                  />
                </CCol>-->
              </CRow>
  
              <CRow v-if="isFijo">
                <CCol sm="11" md="8" lg="8">
                  <CInput
                    disabled
                    v-model="cantidadCosto"
                    :label="`Cantidad a pagar${getUnidadPagar()}:`"
                    placeholder="Cantidad a pagar..."
                    type="number"
                  />
                </CCol>
                <CCol>
                  <label>Tiempo extra:</label>
                  <br />
                  <CSwitch
                    disabled
                    :checked="tiempo_extra"
                    class="mx-1"
                    color="primary"
                    variant="3d"
                  />
                </CCol>
              </CRow>
  
              <CRow>
                <CCol sm="9" md="9" lg="9">
                  <label>Ubicaciones:</label>
                  <multiselect
                    v-model="multi"
                    :options="ubicaciones"
                    disabled
                    :multiple="true"
                    label="label"
                    track-by="label"
                    placeholder="Selecciona uno o varias ubicaciones"
                  />
                </CCol>
              </CRow>
  
              <CRow>
                <CCol>
                  <label>Comentarios:</label>
                  <CTextarea v-model="comentarios" disabled horizontal />
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="12" md="9" lg="9">
                  <KlayFileDD
                    :fetching="fetching"
                    v-model="medias"
                    :label="`Anexos: `"
                    @onFetch="onFetch"
                    @onErrorFetch="(err)=>{
                      fetching=false;
                      error=err
                      warningModal=true
                    }"
                    :fetchMethod="pushMedia"
                    :baseSrc="$store.getters.MediaGet"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CButton v-if="fetching" class="px-4 mx-3 btn-lg" color="success">
                  <i class="fa fa-spinner fa-pulse"></i>
                </CButton>
                <CButton v-else @click="()=>{fetching=true}" class="px-4 mx-3 btn-lg" color="success">
                  <span>Actualizar</span>
                </CButton>
              </CRow>
              <CModal
                size="sm"
                title="Prestación"
                :centered="true"
                color="warning"
                :show.sync="warningModal"
              >{{ error }}</CModal>
              <CModal
                size="sm"
                title="Prestación"
                :centered="true"
                color="success"
                :show.sync="successModal"
                >Guardado con éxito.
                <template #footer>
                  <CButton @click="successModal = false"  color="success">Aceptar</CButton>
                </template>
              </CModal>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>
  </template>
  
  <script>
  import Multiselect from "vue-multiselect";
  import moment from "moment";
  
  export default {
    name: "VerPrestacion",
  
    components: {
      Multiselect
    },
  
    data() {
      return {
        folio: this.$route.params.id,
        config: this.$route.params.config,
        backInfo:this.$route.params.backInfo||'Prestacion',
        item: {},
        date: null,
        multi: null,
        cantidad: 1,
        cantidadCosto: 0,
        trabajador: null,
        trabajadores: [],
        trabajadoresAll: [],
        comentarios: '',
        categoriasAll: [],
        actividad: null,
        actividades: [],
        actividadesAll: [],
        ubicacion: null,
        ubicaciones: [],
        ubicacionesAll: [],
        isLoading: false,
        tiempo_extra: false,
        isFijo: false,
        successModal: false,
        warningModal: false,
        error: "",
        isLoadingPage: false,
        currentAlertCounter: 0,
        fetching: false,
        medias:[],
        loader: false,
      };
    },
  
    computed: {
      ubicacionRaiz() {
        return this.$store.state.rootLocation
          ? this.$store.state.rootLocation.value
          : "";
      }
    },
  
    created() {
     this.fetchData()
    },
    watch: {
      ubicacionRaiz(){
        this.fetchData()
      }
    },
    methods: {
      fetchData(){
         this.isLoading = true;
        this.$store;
  
        const ubi = [
          this.$store.dispatch("customDocumentoHTTP", {
            schema: "prestaciones",
            filter: {
              wherein: [
                {
                  field: "payload->encabezado->ubicacion_raiz_id",
                  value: [this.ubicacionRaiz]
                }
              ],
              where: [
                {
                  field: "folio",
                  value: this.folio,
                  operator: "="
                }
              ]
            },
            ["with-storage"]: ["*"]
          })
        ];
  
        Promise.all(ubi)
          .then(([item]) => {
            if(item.data.length===0){
              return
            }
            this.item = item.data[0];
            
            this.trabajador = this.item.payload.encabezado._relaciones.trabajador.payload.nombre;
            this.comentarios = this.item.payload.encabezado.comentarios
            this.actividad = this.item.payload.encabezado._relaciones.actividad.payload.nombre;
            this.cantidad = this.item.payload.encabezado.cantidad;
            this.cantidadCosto = this.item.payload.encabezado.cantidad_costo;
            this.tiempo_extra = this.item.payload.encabezado.tiempo_extra;
            this.medias = this.item.payload.anexos;
            this.filtrarActividad();
            
            const newMult = this.item.payload.encabezado._relaciones.ubicacion
                .filter(ubi => ubi.id)
                .map(ubicacion => {
                  return { value: ubicacion.id, label: ubicacion.payload.nombre };
                });
            this.multi = newMult;
            this.date = moment(this.item.payload.encabezado.fechahora,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
          })
          .finally(() => (this.isLoading = false));
      },
      getReporte(){
        if(this.loader){
          return
        }
        this.loader = true
        this.$forceUpdate();
        const reportCall = {
          reporte: "formato_prestaciones",
          params: { folio:this.$route.params.id, ubicaciones: [this.ubicacionRaiz]},
          pdf : true
        };
  
        // console.log(reportCall);
        // call.push(reportCall);
  
        
          this.$store.dispatch("reportsPDFHttp", {
            ...reportCall
          }).then(res => {
  
            const blob = res;
  
            let a = document.createElement("a");
            a.style = "display: none";
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = "Reporte de prestaciones.pdf";
            a.click();
            window.URL.revokeObjectURL(url);
          })
          .catch(rej => {
            // console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
          })
  
          .finally(() => {
            this.loader = false
            this.$forceUpdate();
          });
      },
      async onFetch(medias){
        this.fetching=false
        const {folio,serie,schema,payload} = this.item
        const body = Object.assign({},JSON.parse(JSON.stringify({folio,serie,schema,payload})))
        body.payload.anexos = medias
        delete body.payload.encabezado._relaciones
        this.$store.dispatch("customDocumentoRemplazarHTTP",body)
          .then(()=>{
            this.currentAlertCounter = 6;
              // console.log(res.data);
              // this.$router.push({ name: "Produccion" });
          })
          .catch(rej => {
            // console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
            this.fetching=false
            return;
          })
  
          .finally(() => {
            this.fetching=false
            if (!this.warningModal) {
              this.successModal = true;
            }
          });
        
      },
      async pushMedia(files) {
        const arr = [];
        
        for (const v of files.map(async (m) => {
          // eslint-disable-next-line no-extra-boolean-cast
          if(!!m.media){
            return Promise.resolve({data:m,status:"success"})
          }
          const formData = new FormData();
          formData.append("media", m);
          const promise = await this.$store.dispatch("customImageHTTP", formData);
  
          return promise;
        })) {
          const media = await v;
          if (media.status === "success") {
            arr.push(media.data);
          }
        }
        return arr;
        /*
          const formData = new FormData()
          formData.append('media', format.dataURLtoFile(this.fileList[0].thumbUrl))
          this.$store.dispatch('MEDIA_CARGAR', formData)
        */
      },
      getUnidad() {
        if (this.actividad) {
          const actSelect = this.actividadesAll.find(
            actividad => actividad.id == this.actividad
          );
          console.log(actSelect);
  
          return actSelect ? ` (${actSelect.payload.unidad})` : "";
        }
        return "";
      },
      getUnidadPagar() {
        if (this.actividad && this.trabajador) {
          let tipo_pago = "";
          const actSelect = this.actividadesAll.find(
            actividad => actividad.id == this.actividad
          );
          actSelect ? (tipo_pago = actSelect.payload.tipo_pago) : "";
  
          if (tipo_pago == "fijo") {
            const trabSelect = this.trabajadoresAll.find(
              trabajador => trabajador.id == this.trabajador
            );
            if (trabSelect) {
              return this.tiempo_extra
                ? ` (${trabSelect.payload.unidad_extra})`
                : ` (${trabSelect.payload.unidad})`;
            }
          }
        }
        return "";
      },
      filtrarActividad() {
        if (this.actividad) {
          const actSelect = this.actividadesAll.find(
            actividad => actividad.id == this.actividad
          );
          if (actSelect) {
            actSelect.payload.tipo_pago === "fijo"
              ? (this.isFijo = true)
              : (this.isFijo = false);
          }
        }
      }
    }
  };
  </script>
  
  <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
  <style src="spinkit/spinkit.min.css"></style>
  
  <style scoped>
  .catalogo-text {
    font-size: 1.2rem !important;
  }
  .line {
    color: #321fdb; /* old IE */
    background-color: #321fdb; /* Modern Browsers */
  }
  @media (max-width: 420px) {
    .btn-header {
      padding-left: 8px;
      padding-right: 8px;
      font-size: 12px;
    }
    .padding-sm {
      padding-left: 10px;
      padding-right: 10px;
    }
    .text-sm {
      font-size: 11px !important;
    }
    .margin-sm {
      margin: 5px;
    }
  }
  </style>
  